import { Component } from '@angular/core';
import {Base64ImageComponent} from "../base64-image/base64-image.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {Store} from "@ngrx/store";
import {ActivatedRoute, Router} from "@angular/router";
import {FilesService} from "../../services/files/files.service";
import {IconsService} from "../../services/icons.service";
import {ChatsService} from "../../services/chats.service";
import * as UserSelectors from "../../state/users/users.selector";
import {interfaceActions} from "../../state/interface/interface.actions";
import * as EntitySelectors from "../../state/entities/entity.selector"
import {Entity} from "../../state/entities/entity.model";
import {UsersService} from "../../services/users.service";
import {NgIf} from "@angular/common";
import {entityActions} from "../../state/entities/entity.actions";
import {EventsWebsocketService} from "../../services/entities/events-websocket.service";

@Component({
  selector: 'context-post',
  standalone: true,
    imports: [
        Base64ImageComponent,
        FaIconComponent,
        NgIf
    ],
  templateUrl: './context-post.component.html',
  styleUrl: './context-post.component.scss'
})
export class ContextPostComponent {

    entityId: string = null
    entity: Entity = null
    userIsOwner: boolean = false
    constructor(
        private store: Store,
        private route: ActivatedRoute,
        protected iconsService: IconsService,
        private chatService: ChatsService,
        private usersService: UsersService,
        private eventsWebsocketService: EventsWebsocketService,
        private router: Router
    ) {
        this.route.queryParams.subscribe(params => {
            this.entityId = params["entityId"];
            this.store.select(EntitySelectors.selectEntityById({entityId: this.entityId})).subscribe(async (user) => {
                this.entity = user
                this.userIsOwner = this.entity.ownerId === this.usersService.user.id
            })
        });
    }

    async closeContextMenu() {
        await this.router.navigate( [{outlets: {'context-menu': null}}], { queryParamsHandling: 'preserve' })
        this.store.dispatch(interfaceActions.closeContextMenu())
    }

    async delete() {
        if (confirm("Are you sure you want to delete this post? It will be gone forever.")) {
            await this.eventsWebsocketService.dispatch(entityActions.netDestroyed({id: this.entityId}))
            await this.closeContextMenu()
        }
    }

    viewProfile() {

    }

    protected readonly location = location;
}
